import { render, staticRenderFns } from "./ProductKind.vue?vue&type=template&id=7678e925"
import script from "./ProductKind.vue?vue&type=script&lang=js"
export * from "./ProductKind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports